import { useEffect, useState } from 'react'
import { useGetLanguage } from '../useGetLanguage'
import enStrings from 'react-timeago/lib/language-strings/en'
import deStrings from 'react-timeago/lib/language-strings/de'
import esStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'

const enFormatter = buildFormatter(enStrings);
const deFormatter = buildFormatter(deStrings);
const esFormatter = buildFormatter(esStrings);

interface useTimeAgoFormatterOutput {
    formatter: any
}
function useTimeAgoFormatter(): useTimeAgoFormatterOutput {
    const { language } = useGetLanguage();
    const [formatter, setFormatter] = useState<any>(() => enFormatter);

    useEffect(() => {
        if (language === "de" || language.startsWith("de-") || language.startsWith("deu")) {
            setFormatter(() => deFormatter)
        }
        else if (language === "es" || language.startsWith("es-")) {
            setFormatter(() => esFormatter)
        }
        else {
            setFormatter(() => enFormatter)
        }
    }, [language]);

    return { formatter: formatter }
}

export default useTimeAgoFormatter